/* eslint-disable no-useless-escape */
import _ from 'lodash';
import isAfter from 'date-fns/isAfter';
import isValid from 'date-fns/isValid';
import isSameHour from 'date-fns/isSameHour';
import isSameMinute from 'date-fns/isSameMinute';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';

const createDateFromTextValue = (value) => {
    const splitParts = value.split(':');
    return new Date(1970, 1, 1, splitParts[0], splitParts[1]); // add time to any date
};

const Validation = {
    validateAllRules(validateRules) {
        const results = {};
        _.forEach(validateRules, (rules, key) => {
            for (let i = 0; i < rules.length; i += 1) {
                const validatorRule = rules[i];
                const validateResult = validatorRule();
                if (validateResult && validateResult.result !== 'success') {
                    results[key] = validateResult;
                    break;
                }
            }
        });
        return results;
    },

    isNotEmpty(value) {
        if (_.isNil(value) || value === '' || (_.isString(value) && value.trim() === '')) {
            return {
                result: 'error',
                message: 'validation.required',
            };
        }

        return {
            result: 'success',
        };
    },

    isAnyCheckboxSelected(arr) {
        const a = arr.some((x) => x === true);
        if (a) {
            return {
                result: 'success',
            };
        }
        return {
            result: 'error',
            message: 'validation.requiredMultipleCheckboxes',
        };
    },

    validatePhoneNumber(value) {
        if (!value) {
            return { result: 'success' };
        }

        if (value.split('-').includes('') && !new RegExp(/^[0-9]{10,11}$/).test(value)) {
            return {
                result: 'error',
                message: 'validation.phoneNumber',
            };
        }

        if (value.length !== 12 && value.length !== 13 && !new RegExp(/^[0-9]{10,11}$/).test(value)) {
            return {
                result: 'error',
                message: 'validation.phoneNumber',
            };
        }

        if (!new RegExp(/[0-9]{2,5}\-[0-9]{1,4}\-[0-9]{3,4}/g).test(value) && !new RegExp(/^[0-9]{10,11}$/).test(value)) {
            return {
                result: 'error',
                message: 'validation.phoneNumber',
            };
        }

        return {
            result: 'success',
        };
    },

    validateDuplicateMail(email, emailArray) {
        let i = 0;
        // eslint-disable-next-line no-return-assign,
        emailArray.map((item) => (item === email ? i += 1 : i));
        if (!_.isEmpty(emailArray) && email && i > 1) {
            return {
                result: 'error',
                message: 'validate.duplicateEmail',
            };
        }
        return {
            result: 'success',
        };
    },

    validateEmail(value) {
        if (value) {
            const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i;
            if (!regexEmail.test(value)) {
                return {
                    result: 'error',
                    message: 'validation.email',
                };
            }

            return {
                result: 'success',
            };
        }
        return {
            result: 'success',
        };
    },

    validateFax(value) {
        if (value) {
            if (value.length !== 12 && value.length !== 13) {
                return {
                    result: 'error',
                    message: 'validation.fax',
                };
            }

            if (!new RegExp(/[0-9]{2,5}\-[0-9]{1,4}\-[0-9]{3,4}/g).test(value)) {
                return {
                    result: 'error',
                    message: 'validation.fax',
                };
            }

            return {
                result: 'success',
            };
        }
        return {
            result: 'success',
        };
    },

    validateMaxLength(value, maxLength, type) {
        const length = !_.isNil(value) ? value.length : 0;
        if (typeof type !== 'undefined' && type === 'textarea') {
            if (value && length > maxLength) {
                return {
                    result: 'error',
                    message: 'validation.maxLength',
                };
            }
        }
        if (value && length > maxLength) {
            return {
                result: 'error',
                message: 'validation.maxLength',
            };
        }

        return {
            result: 'success',
        };
    },
    validateLimitLengthZone(value) {
        if (value && (value.length > 20 || value.length < 1)) {
            return {
                result: 'error',
                message: 'validate.limitLengthZone',
            };
        }
        return {
            result: 'success',
        };
    },

    validateKanaChar(value) {
        if (value && new RegExp(/[^\u30A1-\u30FA|\uFF66-\uFF6F|\uFF71-\uFF9D|\u3000\u0020\u30FC\u2010\u002D\u2015\uFF0D\u2212\uFF70]+|[\|]+/).test(value)) {
            return {
                result: 'error',
                message: 'validation.kanaChar',
            };
        }
        return { result: 'success' };
    },

    isValidUrl(value) {
        if (value && !new RegExp(/^http:\/\/|^https:\/\//).test(value)) {
            return {
                result: 'error',
                message: 'validation.url',
            };
        }
        return { result: 'success' };
    },

    isCheck(value) {
        if (value === false) {
            return {
                result: 'error',
                message: 'validation.requiredCheckbox',
            };
        }

        return {
            result: 'success',
        };
    },

    validateSame(oldValue, newValue) {
        if (oldValue !== newValue) {
            return {
                result: 'error',
                message: 'validation.sameValue',
            };
        }

        return {
            result: 'success',
        };
    },
    isPositiveNumbers(value) {
        if (_.isNil(value) || Number(value) < 1) {
            return {
                result: 'error',
                message: 'validation.positiveNumber',
            };
        }

        return {
            result: 'success',
        };
    },

    validateZipCode(value) {
        if (value && !new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/).test(value)) {
            return {
                result: 'error',
                message: 'zipCode',
            };
        }
        return { result: 'success' };
    },

    validateDateFormat(date) {
        if (!isValid(new Date(date))) {
            return {
                result: 'error',
                message: 'validation.dateTime',
            };
        }
        return {
            result: 'success',
        };
    },

    validateTimeFormat(time) {
        const temp = createDateFromTextValue(time);
        if (!isValid(new Date(temp))) {
            return {
                result: 'error',
                message: 'validation.dateTime',
            };
        }
        return {
            result: 'success',
        };
    },

    validateDateRanger(startDate, endDate) {
        if (isAfter(new Date(startDate), new Date(endDate))) {
            return {
                result: 'error',
                message: 'validation.dateRange',
            };
        }
        return {
            result: 'success',
        };
    },

    splitTime(time) {
        const splitTime = time.split(':');
        return {
            hour: splitTime[0],
            minute: splitTime[1],
        };
    },

    validateTimeRanger(startTime, endTime) {
        const tempStart = createDateFromTextValue(startTime);
        const tempEnd = createDateFromTextValue(endTime);
        if (isAfter(new Date(tempStart), new Date(tempEnd))) {
            return {
                result: 'error',
                message: 'validation.dateRange',
            };
        }
        return {
            result: 'success',
        };
    },

    validateStartTime(startTime, dates) {
        const today = format(new Date(), 'yyyy-MM-dd');
        const currentTime = format(new Date(), 'HH:mm');
        if (dates.includes(today) && (startTime < currentTime)) {
            return {
                result: 'error',
                message: 'ライブ配信開始時間は現在時間以降で指定してください。',
            };
        }
        return {
            result: 'success',
        };
    },

    validateTimeSame(startTime, endTime) {
        const tempStart = createDateFromTextValue(startTime);
        const tempEnd = createDateFromTextValue(endTime);
        if (isSameMinute(new Date(tempStart), new Date(tempEnd)) && isSameHour(new Date(tempStart), new Date(tempEnd))) {
            return {
                result: 'error',
                message: 'validation.timeRange',
            };
        }
        return {
            result: 'success',
        };
    },

    validateDuplicateDates(dateArray) {
        const date = new Set(dateArray);
        if (dateArray && dateArray.length !== date.size) {
            return {
                result: 'error',
                message: 'ライブ配信で異なる日付を入力してください。',
            };
        }
        return {
            result: 'success',
        };
    },

    validateSelectionDates(dateArray, disableDateArray) {
        const duplicates = disableDateArray.filter((filterDateDuplicate) => dateArray.indexOf(filterDateDuplicate) !== -1);
        if (!_.isEmpty(duplicates)) {
            return {
                result: 'error',
                message: '選択した日付はライブ配信が登録されました。',
            };
        }
        return {
            result: 'success',
        };
    },

    validateArr(arr) {
        if (arr.length > 0) {
            return {
                result: 'success',
            };
        }
        return {
            result: 'error',
            message: 'validation.requiredArray',
        };
    },

    isNumber(value) {
        if (!Number.isNaN(Number(value))) {
            return { result: 'success' };
        }
        return {
            result: 'error',
            message: 'validation.number',
        };
    },

    isInt(value) {
        if (Number.isInteger(Number(value))) {
            return { result: 'success' };
        }
        return {
            result: 'error',
            message: 'validation.integer',
        };
    },

    isNonNegative(value) {
        if (value >= 0) {
            return { result: 'success' };
        }
        return {
            result: 'error',
            message: 'validation.nonNegativeNumber',
        };
    },

    limitValue(value, minValue, maxValue) {
        if (value <= maxValue && value >= minValue) {
            return { result: 'success' };
        }
        return {
            result: 'error',
            message: 'validation.limitValue',
        };
    },
    validateBigWithSmall(big, small) {
        if (Number(small) <= Number(big)) {
            return { result: 'success' };
        }
        return {
            result: 'error',
            message: 'validation.bigWithSmall',
        };
    },
    validateUniqueZone(zones) {
        const filterZone = zones.filter((item) => !_.isEmpty(item.zone_name)).map((item) => item.zone_name);

        const haveDuplicatesValue = filterZone.some(
            (val, i) => filterZone.indexOf(val) !== i,
        );

        if (!haveDuplicatesValue) {
            return { result: 'success' };
        }

        return {
            result: 'error',
            message: 'validation.unique',
        };
    },
    validateZone(value) {
        if (parseInt(value, 10)) {
            return { result: 'success' };
        }
        return {
            result: 'error',
            message: 'validation.zone',
        };
    },
    noSettingCost(value) {
        if (parseInt(value, 10) !== 0) {
            return { result: 'success' };
        }

        return {
            result: 'error',
            message: 'validation.noSettingCost',
        };
    },

    isNoApplications() {
        return {
            result: 'error',
            message: 'validation.positiveNumber',
        };
    },

    isNumberNotZero(value) {
        if (parseInt(value, 10) > 0) {
            return { result: 'success' };
        }

        return {
            result: 'error',
            message: 'validation.required',
        };
    },
    noCostNotFloat(value) {
        if (parseFloat(value, 10) >= 0) {
            return { result: 'success' };
        }

        return {
            result: 'error',
            message: 'validation.noSettingCost',
        };
    },
    validateCreditExpired(currentDate, dateExpired) {
        if (isAfter(dateExpired, currentDate) || isSameDay(dateExpired, currentDate)) {
            return { result: 'success' };
        }

        return {
            result: 'error',
            message: 'validate.creditExpired',
        };
    },
    validateLimitNumber(value, minNumber) {
        if (value.length >= minNumber) {
            return { result: 'success' };
        }

        return {
            result: 'error',
            message: 'validate.validateLimitNumber',
        };
    },
    validateTextHalfSize(value) {
        if (!new RegExp(/^[a-zA-Z0-9]+$/g).test(value)) {
            return {
                result: 'error',
                message: 'validate.validateTextHalfSize',
            };
        }

        return {
            result: 'success',
        };
    },
    validateHexColor(value) {
        if (!new RegExp('^#(?:[0-9a-fA-F]{3}){1,2}$').test(value)) {
            return {
                result: 'error',
                message: 'validate.validateHexColor',
            };
        }

        return {
            result: 'success',
        };
    },
    isValidIframeAndHttp(value) {
        if (new RegExp(/(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g).test(value) || new RegExp(/^http:\/\/|^https:\/\//).test(value) || _.isEmpty(value)) {
            return {
                result: 'success',
            };
        }
        return {
            result: 'error',
            message: 'validation.urlOrIframe',
        };
    },
    validatePassword(value) {
        if (new RegExp(/^[a-zA-Z0-9]{6,32}$/).test(value)) {
            return {
                result: 'success',
            };
        }
        return {
            result: 'error',
            message: 'validate.validatePassword',
        };
    },
    validateTextLatin(value) {
        if (!new RegExp(/^[a-zA-Z0-9]+$/g).test(value)) {
            return {
                result: 'error',
                message: 'validate.validateTextLatin',
            };
        }

        return {
            result: 'success',
        };
    },
    validateLatin(value) {
        if (new RegExp(/^[A-z0-9\u00C0-\u00ff\s'\.,-[\]@|+?/#!$%\^&\/"><*;:{}=\-_`~()]+$/).test(value)) {
            return {
                result: 'success',
            };
        }

        return {
            result: 'error',
            message: 'validate.validateLatin',
        };
    },
    validateUniqueZoneEN(zoneArray, value) {
        let i = 0;
        // eslint-disable-next-line no-return-assign,
        zoneArray.map((item) => (item === value ? i += 1 : i));

        if (!_.isEmpty(zoneArray) && value && i > 1) {
            return {
                result: 'error',
                message: 'validation.unique',
            };
        }

        return { result: 'success' };
    },
};

export default Validation;
